




export const COMMENTS_TRANSFORM_POSITION = 'COMMENTS_TRANSFORM_POSITION';

const getStorageCommentsPosition = () => {
  const positions = localStorage.getItem(COMMENTS_TRANSFORM_POSITION);

  return positions ? JSON.parse(positions) : {};
};

export const addCommentPosition = (
commentId,
transformPosition) =>
{
  const commentsPosition = getStorageCommentsPosition();

  commentsPosition[commentId] = transformPosition;
  localStorage.setItem(COMMENTS_TRANSFORM_POSITION, JSON.stringify(commentsPosition));
};

export const getCommentPosition = (commentId) => {
  const commentsPosition = getStorageCommentsPosition();

  return commentsPosition[commentId];
};

export const removeCommentsPosition = () => {
  localStorage.removeItem(COMMENTS_TRANSFORM_POSITION);
};